import styled from 'styled-components'

import { Devices, Spacings, Text } from '@styles'

import { VehicleFields } from '../style'

// S id -> F id -> D id, one chip per id with an arrow between
export const IdChain = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

export const IdChip = styled.div`
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
`

// the drawer's submit button, at the right end of its row
export const SubmitRow = styled.div`
	display: flex;
	justify-content: flex-end;
`

// the invoice number and remarks, enclosed in a thin rounded border
export const RemarksCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_3B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
`

// vehicle number, driver number, quantity, status pill, then the actions
export const VehicleFieldsWithStatus = styled(VehicleFields)`
	@media ${Devices.tablet} {
		grid-template-columns: repeat(3, minmax(0, 1fr)) auto auto;
	}
`

// an empty label-sized line on top, so the pill sits level with the input boxes
export const VehicleStatusCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};

	&::before {
		content: '\\00a0';
		font-size: ${Text.EXTRA_SMALL};
		font-weight: ${Text.BOLD_600};
	}
`
